import { isAbsolute, join } from 'node:path';
import fs from 'node:fs';

/**
 * Resolve log directory path
 */
export function resolveLogDir(provided?: string): string {
  if (!provided) {
    return join(process.cwd(), 'logs');
  }
  return isAbsolute(provided) ? provided : join(process.cwd(), provided);
}

/**
 * Ensure directory exists, create if not
 */
export function ensureDir(dir: string): void {
  if (!fs.existsSync(dir)) {
    fs.mkdirSync(dir, { recursive: true });
  }
}

/**
 * Serialize error for JSON response
 */
export function serializeError(error: unknown): { name?: string; message: string } {
  return error instanceof Error
    ? { name: error.name, message: error.message }
    : { message: String(error) };
}
